export default __webpack_public_path__ + "static/media/mb4.52c4c739.jpg";